import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "gfu-issue__option-header",
  "data-qa": "issue-card-header"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "_tc--light _mt-3"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["gfu-collapsible gfu-issue__option-wrapper", {'gfu-issue__option-wrapper--expanded gfu-collapsible--expanded': _ctx.isOpen }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["gfu-collapsible gfu-issue__option gfu-issue__option-collapsible", {'gfu-issue__option-collapsible--expanded': _ctx.isOpen }]),
      onClick: _cache[0] || (_cache[0] = (...args) => ($options.onHeaderClick && $options.onHeaderClick(...args)))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["gfu-issue__option-collapsible-icon", {'gfu-issue__option-collapsible-icon--expanded': _ctx.isOpen}])
      }, null, 2 /* CLASS */),
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "header", {}, () => [
          ($props.header)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "gfu-issue__option-title gfu-issue__option-title--deemphasized",
                innerHTML: $options.formattedHeader
              }, null, 8 /* PROPS */, _hoisted_2))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ], 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass(["gfu-collapsible__content _pa-4 _bgc--white gfu-collapsible__content--no-rounded gfu-issue__option-collapsible-content", {'gfu-collapsible__content--expanded': _ctx.isOpen}])
    }, [
      ($props.content)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "gfu-richtext",
            innerHTML: $props.content,
            "data-qa": "issue-card-content"
          }, null, 8 /* PROPS */, _hoisted_3))
        : _createCommentVNode("v-if", true),
      ($props.editedAt)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.Resources.Common.LastUpdatedAtLabel) + " " + _toDisplayString($options.editedAtDateFormatted), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _renderSlot(_ctx.$slots, "subContent")
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}